import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Input, message, Tag } from 'antd';
import { InputContainer, InputLabel, ModalTagContainer } from '../../components/Modals/styles';
import REGEX from "../../utils/regex";
import { SEND_TEST_EMAIL_MODAL, SEND_EMAIL_MODAL } from '../../components/Modals/translationValues';
import { SendEmailModal } from '../../artboard/VariablesList/styles';

const NAMESPACES = ['SEND_TEST_EMAIL_MODAL', 'SEND_EMAIL_MODAL'];

class SendTestEmailModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: [],
      inputVisible: true,
      inputValue: '',
      editInputIndex: -1,
      editInputValue: '',
      borderVisibility: null,
      defaultSmtp: true,
      password: '',
      ccAddresses: [],
      ccInputValue: '',
    };
    this.passwordRef = React.createRef(null);
  }

  handleClose = (removedTag, ccAddress = false) => {
    const { addresses, ccAddresses } = this.state;
    const selectedAddresses = ccAddress ? ccAddresses : addresses;
    this.setState({
      [ccAddress ? 'ccAddresses' : 'addresses']: selectedAddresses.filter(
        tag => tag !== removedTag,
      ),
    });
  };

  handleInputChange = (e, ccAddress = false) => {
    this.setState({
      [ccAddress ? 'ccInputValue' : 'inputValue']: e.target.value,
      borderVisibility: ccAddress ? 'ccAddress' : 'toAddress',
    });
  };

  handleInputConfirm = (ccAddress = false) => {
    const { t } = this.props;
    const { inputValue, ccInputValue, addresses, ccAddresses } = this.state;
    const inputVal = ccAddress ? ccInputValue : inputValue;
    const selectedAddresses = ccAddress ? ccAddresses : addresses;
    let trimedTag = inputVal.trim().replace(/\s/g, '');
    if (trimedTag.length > 0) {
      const isValidEmail = REGEX.EMAIL.test(trimedTag);
      if (!isValidEmail) {
        message.error(t(SEND_TEST_EMAIL_MODAL.INVALID_EMAIL_ERROR_MESSAGE.key, SEND_TEST_EMAIL_MODAL.INVALID_EMAIL_ERROR_MESSAGE.value));
        return;
      }
      let exists = selectedAddresses.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
      if (!exists) {
        selectedAddresses.push(trimedTag);
      } else {
        message.error(t(SEND_EMAIL_MODAL.EMAIL_ALREADY_EXISTS_ERROR.key, SEND_EMAIL_MODAL.EMAIL_ALREADY_EXISTS_ERROR.value));
      }
    }
    this.setState({
      [ccAddress ? 'ccAddresses' : 'addresses']: selectedAddresses,
      [ccAddress ? 'ccInputValue' : 'inputValue']: '',
    });
  };

  saveInputRef = input => {
    this.input = input;
  };

  sendTestEmail = async () => {
    const { addresses, ccAddresses, password } = this.state;
    this.props.setErrorMessages({})
    if (addresses.length > 0) {
      const { sendTestEmail } = this.props;
      sendTestEmail(addresses, ccAddresses, password);
    } else {
      message.error(this.props.t(
        `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE.key}`,
        SEND_EMAIL_MODAL.EMPTY_ADD_RECIPIENTS_ERROR_MESSAGE.value
      ));
    }
  };

  handleInputFocus = (ccAddress = false) => {
    this.setState({
      borderVisibility: ccAddress ? 'ccAddress' : 'toAddress',
    });
  };

  handleInputOutofFocus = (ccAddress) => {
    this.handleInputConfirm(ccAddress);
    this.setState({
      borderVisibility: null,
    });
  };

  defaultSMTPChange = e => {
    this.setState({ defaultSmtp: e.target.checked});
  };

  onChangePassword = (e) => {
    this.setState({
      password: e.target.value
    });
  }

  render() {
    const { t, onCancel, isLoading } = this.props;
    const { addresses, inputValue, borderVisibility, ccAddresses, ccInputValue } = this.state;
    return (
      <SendEmailModal
        width="600px"
        centered
        maskClosable={false}
        visible={true}
        onCancel={() => onCancel(false)}
        footer={[
          <Button key="back" onClick={() => onCancel(false)}>
            {t(SEND_TEST_EMAIL_MODAL.CANCEL_BUTTON.key, SEND_TEST_EMAIL_MODAL.CANCEL_BUTTON.value)}
          </Button>,
          <Button key="Send Mail" type="primary" loading={isLoading} onClick={this.sendTestEmail} disabled={this.props.showPassword && this.state.password === ''}>
            {isLoading
              ? `${t(SEND_EMAIL_MODAL.SENDING_EMAIL_BUTTON.key, SEND_EMAIL_MODAL.SENDING_EMAIL_BUTTON.value)} ...`
              : t(SEND_EMAIL_MODAL.SEND_BUTTON.key, SEND_EMAIL_MODAL.SEND_BUTTON.value)}
          </Button>,
        ]}
        title={t(SEND_EMAIL_MODAL.SEND_EMAIL_TITLE.key, SEND_EMAIL_MODAL.SEND_EMAIL_TITLE.value)}
      >
        <InputLabel className='label'>
          {t(SEND_EMAIL_MODAL.TO_LABEL.key, SEND_EMAIL_MODAL.TO_LABEL.value)}: <span>*</span>
        </InputLabel>
        <ModalTagContainer border={borderVisibility === 'toAddress'}>
          {addresses.map((emailAddress, index) => {
            return (
              <Tag
                className="edit-tag"
                key={emailAddress}
                closable={true}
                onClose={() => this.handleClose(emailAddress)}
                color="#df4c35"
              >
                <span title={emailAddress}>{emailAddress}</span>
              </Tag>
            );
          })}
          <InputContainer tagInput>
            <Input
              name="emailAddress"
              ref={this.saveInputRef}
              type="text"
              className="tag-input"
              value={inputValue}
              onFocus={() => this.handleInputFocus()}
              onChange={(e) => this.handleInputChange(e)}
              onBlur={() => this.handleInputOutofFocus()}
              onPressEnter={() => this.handleInputConfirm()}
              placeholder={t(SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.key, SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.value)}
              autoComplete={"off"}
            />
          </InputContainer>
        </ModalTagContainer>
        <InputLabel className='label'>
          {t(SEND_EMAIL_MODAL.CC_LABEL.key, SEND_EMAIL_MODAL.CC_LABEL.value)}:
        </InputLabel>
        <ModalTagContainer border={borderVisibility === 'ccAddress'}>
          {ccAddresses.map((emailAddress, index) => {
            return (
              <Tag
                className="edit-tag"
                key={emailAddress}
                closable={true}
                onClose={() => this.handleClose(emailAddress, true)}
                color="#df4c35"
              >
                <span title={emailAddress}>{emailAddress}</span>
              </Tag>
            );
          })}
          <InputContainer tagInput>
            <Input
              name="emailAddress"
              ref={this.saveInputRef}
              type="text"
              className="tag-input"
              value={ccInputValue}
              onFocus={() => this.handleInputFocus(true)}
              onChange={(e) => this.handleInputChange(e, true)}
              onBlur={() => this.handleInputOutofFocus(true)}
              onPressEnter={() => this.handleInputConfirm(true)}
              placeholder={t(SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.key, SEND_TEST_EMAIL_MODAL.ADD_MAIL_ADDRESS_PLACEHOLDER.value)}
              autoComplete={"off"}
            />
          </InputContainer>
        </ModalTagContainer>
        {this.props.showPassword && (
              <>
                <InputLabel style={{ marginTop: 5 }}>
                  {t(SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_LABEL.key, SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_LABEL.value)}
                </InputLabel>
                <InputContainer>
                    <Input
                      name="password"
                      ref={this.passwordRef}
                      type="text"
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const paste = e.clipboardData.getData('text');
                        if (paste.includes(' ')) {
                          e.preventDefault();
                          const cleaned = paste.replace(/\s/g, '');;
                          this.setState({ password: cleaned });
                          this.onChangePassword(e);
                        }
                      }}
                      onChange={this.onChangePassword}
                      placeholder={t(SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_PLACEHOLDER.key, SEND_TEST_EMAIL_MODAL.ENTER_PASSWORD_PLACEHOLDER.value)}
                      autoComplete={"off"}
                     />
                </InputContainer>
              </>
        )}
      </SendEmailModal>
    );
  }
}
export default withTranslation(NAMESPACES)(SendTestEmailModal);